/**
 * Error Boundary for Cart Popup Component
 *
 * @since 1.0.0
 */

import { __ } from '@wordpress/i18n';
import React, { Component } from 'react';

import type { ErrorBoundaryProps, ErrorBoundaryState } from './types';

/**
 * Error boundary component for cart popup
 */
export class CartPopupErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { hasError: true, error };
  }

  override componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    // eslint-disable-next-line no-console
    console.error('CartPopup Error:', error, errorInfo);
  }

  override render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback;
      }

      return (
        <div className='redfox-added-to-cart-popup__cart-content'>
          <div className='redfox-added-to-cart-popup__error-message'>
            <span className='redfox-added-to-cart-popup__error-icon'>⚠</span>
            {__('Something went wrong while loading the cart popup.', 'redfox-added-to-cart-popup')}
          </div>
          <div className='redfox-added-to-cart-popup__actions'>
            <button
              className='redfox-added-to-cart-popup__btn redfox-added-to-cart-popup__btn--continue'
              onClick={() => window.location.reload()}
            >
              {__('Reload Page', 'redfox-added-to-cart-popup')}
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
